import React, { useState, useCallback, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import HelpIcon from "@mui/icons-material/HelpOutlineOutlined";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import { SpeedDial, SpeedDialAction } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import StarFullfilledIcon from "@mui/icons-material/Star";
import StarIcon from "@mui/icons-material/StarBorderTwoTone";
// import GetAppIcon from "@mui/icons-material/GetApp";
import TimelineIcon from "@mui/icons-material/Timeline";

import { downloadInfo, getSecurityInfo } from "../store/ducks/duckSecurity";
import { useUser } from "../auth/UserProvider";
import confidentialityIcon from "../icons/index";
import { addFavorite, deleteFavorite } from "../store/ducks/duckFavorites";

const useStyles = makeStyles(() => ({
  rootSimple: {
    position: "relative",
    marginLeft: "auto",
    marginRight: 20,
    float: "right",
    marginBottom: 0,
    marginTop: "auto",
    height: "calc(100% - 57px)",
  },
  rootWithTabs: {
    position: "relative",
    marginLeft: "auto",
    marginRight: 20,
    float: "right",
    marginBottom: 0,
    marginTop: "auto",
    height: "calc(100% - 90px)",
  },
  tooltip: {
    backgroundColor: "rgba(0,0,0,0.70)",
    color: "white",
  },
  star: {
    color: "rgb(218, 197, 0)",
    cursor: "pointer",
  },
}));

// const fileDownload = require("js-file-download");

const CONFIDENTIAL_URL =
  "https://techintingenieria.sharepoint.com/sites/tda/SitePages/Data-Classifications--.aspx";

export default function ControlComponent({ simple = false, tabId = null, isCustom = false }) {
  const classes = useStyles();
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(true);
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.security.dataSecurity);
  const { isAdmin, isOwner: userIsOwner, networkUser } = useUser();

  const { pathname } = useLocation();

  const isOwner = useSelector((state) => {
    let tab = null;

    let validOwner = userIsOwner;

    tab = state.layout.layoutSelected?.tabs?.find((x) => x.tabId === tabId);

    return tab ? validOwner && tab.isOwner : validOwner && state.layout.layoutSelected?.isOwner;
  });

  const confidentiality = useSelector((state) => {
    let tab = state.layout.layoutSelected?.tabs?.find((x) => x.tabId === tabId);

    return tab ? tab?.confidentiality : state.layout.layoutSelected?.confidentiality;
  });

  const isFavorite = useSelector((state) => {
    let result;

    if (isCustom) {
      result = state.favorites.data.find((x) => x.isCustom && x.customPath === pathname);
    } else {
      result = state.favorites.data.find((x) => x.layoutId?.toString() === id);
    }

    return result;
  });

  const handleToggleFavorite = (e) => {
    e.preventDefault();

    if (!isFavorite) {
      let favorite = {
        layoutId: isCustom ? 0 : id,
        networkUser,
        isCustom,
        customPath: pathname,
      };

      dispatch(addFavorite(favorite));
    } else {
      dispatch(deleteFavorite(isFavorite.id));
    }
  };

  useEffect(() => {
    const handleTimeOut = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => clearTimeout(handleTimeOut);
  }, []);

  useEffect(() => {
    dispatch(getSecurityInfo());
  }, [dispatch]);

  const handleRedirect = useCallback(
    (e) => {
      e.preventDefault();
      let urlBase = `${window.location.origin}/Reports/Audit/${id}`;

      if (!id) {
        localStorage.setItem("customPathName", pathname);
        urlBase = `${window.location.origin}/Reports/Audit${pathname}`;
      }

      window.open(urlBase, "_blank", "noopener,noreferrer");
    },
    [id, pathname],
  );

  const handleRedirectAnalytics = useCallback(
    (e) => {
      e.preventDefault();
      localStorage.setItem("PathAnalytics", pathname);
      let urlBase = `${window.location.origin}/Reports/AnalyticsFiltered/${id}`;

      if (!id) {
        urlBase = `${window.location.origin}/Reports/AnalyticsFiltered${pathname}`;
      }

      window.open(urlBase, "_blank", "noopener,noreferrer");
    },
    [id, pathname],
  );

  // const handleDownload = () => {
  //   dispatch(downloadInfo(data)).then((response) => {
  //     fileDownload(response.payload.data, "Security.xlsx");
  //   });
  // };

  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  const handleRedirectInfo = () => {
    window.open(CONFIDENTIAL_URL, "_blank", "noopener,noreferrer").focus();
  };

  const getSpeedDialConfidentiality = (key) => {
    if (key === null || key === undefined) return null;

    const { icon, label } = confidentialityIcon[key];

    return (
      <SpeedDialAction
        key={`Confidentiality-${label}`}
        classes={{
          staticTooltipLabel: classes.tooltip,
        }}
        icon={icon}
        tooltipOpen={show}
        tooltipTitle={label}
        onClick={handleRedirectInfo}
      />
    );
  };

  return (
    <SpeedDial
      ariaLabel="SpeedDial Helper"
      classes={{ root: simple ? classes.rootSimple : classes.rootWithTabs }}
      direction={"up"}
      icon={<HelpIcon />}
      open={show || open}
      onClose={handleClose}
      onOpen={handleOpen}
    >
      {getSpeedDialConfidentiality(confidentiality)}
      {(isOwner || isAdmin) && (
        <SpeedDialAction
          key={"Audit"}
          icon={<FindInPageOutlinedIcon />}
          tooltipTitle={"Audit"}
          onClick={handleRedirect}
        />
      )}

      <SpeedDialAction
        key={"Favorite"}
        icon={
          isFavorite ? (
            <StarFullfilledIcon className={classes.star} />
          ) : (
            <StarIcon className={classes.star} />
          )
        }
        tooltipTitle={isFavorite ? "Remove Favorite" : "Add favorite"}
        onClick={handleToggleFavorite}
      />
      {/* <SpeedDialAction
        key={"excel"}
        icon={<GetAppIcon />}
        tooltipTitle={"Download Excel Permissions"}
        onClick={handleDownload}
      /> */}
      {isAdmin ? (
        <SpeedDialAction
          key={"Analytics"}
          icon={<TimelineIcon />}
          tooltipTitle={"Analytics"}
          onClick={handleRedirectAnalytics}
        />
      ) : (
        []
      )}
    </SpeedDial>
  );
}
